/**
 * Arrow keys switch the list row only when nothing above the list owns them:
 * - an open dialog or menu (any overlay with a backdrop) covers the list;
 * - focus is inside an overlay (e.g. dropdown panels appended to body);
 * - a focused dropdown navigates its own options;
 * - a multi-line text field moves its caret.
 */
export function isListKeyboardNavBlocked(event: KeyboardEvent): boolean {
  if (document.querySelector('mat-dialog-container, .cdk-overlay-backdrop-showing')) {
    return true;
  }

  const target = event.target as HTMLElement;
  if (!target || !target.closest) {
    return false;
  }

  return !!target.closest('.cdk-overlay-container')
    || !!target.closest('.ng-select')
    || target.tagName === 'TEXTAREA'
    || target.isContentEditable;
}
